import { render, staticRenderFns } from "./BaseCountrySelection.vue?vue&type=template&id=6b2f52d3&"
import script from "./BaseCountrySelection.vue?vue&type=script&lang=js&"
export * from "./BaseCountrySelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports